module.exports = __webpack_public_path__ + "img/arrow-square.4290a6d0.svg";